export default __webpack_public_path__ + "static/media/youtube-bw.f58c68fc.svg";